import { getPlatformType, isDianpingAppOrWebview, isMeituanAppOrWebview, isWeixinMiniProgramOrWeixinWebview, PlatformType } from '@nibfe/mkt-env-api';
import Navigate from '@nibfe/mkt-navigate-api';
const { invokeJump } = Navigate;
const convertLinkToAppMiddleOpenLink = (url) => {
    return `https://m.dianping.com/awp/hfe/block-page/call-native/meituan.html?url=${encodeURIComponent(url)}`;
};
export const navigateToDetailPage = (detail, monitorNavigateTo, extra) => {
    const { poiId, shopuuid, hotelchannel, shopIdStr } = detail;
    const { isNeedAdd, extraParamsString } = extra || {};
    let mrnUrl = `imeituan://www.meituan.com/mrn?mrn_biz=hotel&mrn_entry=rn-hotel-poidetail&mrn_component=hotel-poidetail&_page_new=1&_speed_mode=1&id=${poiId}&hotelchannel=${hotelchannel ?? '-999'}`;
    if (isNeedAdd && extraParamsString) {
        mrnUrl = `${mrnUrl}&${extraParamsString}`;
    }
    const envokePoiDetailLink = convertLinkToAppMiddleOpenLink(mrnUrl);
    if (isMeituanAppOrWebview()) {
        invokeJump(mrnUrl);
    }
    else if (isDianpingAppOrWebview()) {
        // 点评app
        invokeJump(`dianping://shopinfo?shopuuid=${shopuuid}&id=${shopIdStr}&=&hotelchannel=${hotelchannel ?? '-999'}`);
    }
    else if (isWeixinMiniProgramOrWeixinWebview()) {
        const platformType = getPlatformType();
        switch (platformType) {
            case PlatformType.mtMinaWebview:
                // 美团小程序
                monitorNavigateTo({
                    url: `/hotel/pages/poi/pages/index/index?poiId=${poiId}`,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            case PlatformType.mtHotelMinaWebview:
                // 美团酒店小程序
                monitorNavigateTo({
                    url: `/pages/poi/pages/index/index?poiId=${poiId}`,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            case PlatformType.dpMinaWebview:
                // 点评小程序
                monitorNavigateTo({
                    url: `/packages/hotel/pages/poi/pages/index/index?shopId=${poiId}&shopUuid=${shopuuid}`,
                    _web: {
                        miniProgramNative: true
                    }
                });
                break;
            default:
                monitorNavigateTo({
                    url: envokePoiDetailLink
                });
                break;
        }
    }
    else {
        monitorNavigateTo({
            url: envokePoiDetailLink
        });
    }
};
